import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state: {
    notifications: [],
    unreadCount: 0,
    currentNotification: null,
    isNotificationModalVisible: false,
  },
  mutations,
  actions,
  getters,
};
